import { render } from "./TyreBanners.vue?vue&type=template&id=0e35ba0a&scoped=true"
import script from "./TyreBanners.vue?vue&type=script&lang=js"
export * from "./TyreBanners.vue?vue&type=script&lang=js"

import "./TyreBanners.vue?vue&type=style&index=0&id=0e35ba0a&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e35ba0a"]])

export default __exports__